<template>
  <div
    ref="advancedCarouselRef"
    class="advanced-carousel"
    @mouseenter="changeInterval(true)"
    @mouseleave="changeInterval(false)"
  >
    <!-- Container -->
    <slot>
      <div class="advanced-carousel__no-data">
        No components found.
      </div>
    </slot>
    <!-- Buttons -->
    <div
      v-show="showing"
      class="btn-left"
      @click="previous"
    >
      <div class="btn-left__arrow" />
    </div>
    <div
      v-show="showing"
      class="btn-right"
      @click="next"
    >
      <div class="btn-right__arrow" />
    </div>
    <!-- Footer -->
    <div
      v-show="showing"
      class="advanced-carousel__footer"
    >
      <div
        v-for="(item, index) in items"
        :key="item.id"
        @click="onClick(index, $event)"
      >
        <div class="wrapper-line">
          <div
            v-show="current == index"
            ref="line"
            class="line"
          />
        </div>

        <div class="wrapper-text">
          <span
            class="circle"
            :class="{ 'circle--active' : current == index }"
          />
          <div
            v-if="getResume(item)"
            class="text"
          >
            {{ getResume(item) }}
          </div>
          <div
            v-else
            class="text"
          >
            {{ getTitle(item) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Emitter from 'tiny-emitter'

export default {
  name: 'AdvancedCarousel',
  props: {
    timer: {
      type: Number,
      default: 7
    },
    enableover: {
      type: Boolean,
      default: false
    }
  },
  emits: ['advancedCarouselCurrItem'],
  data() {
    return {
      items: [],
      current: 0,
      loading: 0,
      playing: false,
      interval: null,
      emitter: new Emitter()
    }
  },
  computed: {
    showing() {
      return this.items.length > 1
    }
  },
  watch: {
    loading(value) {
      if (this.$refs.line && this.$refs.line[this.current]) {
        this.$refs.line[this.current].style.width = `${value / 5}%`
      }
    },
    current(current) {
      this.loading = 0
      this.emitToChildrens(current)
      this.changeitem(current, true)
    }
  },
  created() {
    this.emitter.on('initbanner', (item) => {
      this.items.push(item)
    })

    this.emitter.on('playvideo', (play) => {
      this.playing = play

      if (this.enableover) return

      this.changeInterval(play || this.playing)
    })
  },
  mounted() {
    this.items = this.$refs.advancedCarouselRef.querySelectorAll('.vt-wrap-component')

    this.items.forEach((item, index) => {
      if (index > 0) this.changeitem(index)
    })

    this.emitToChildrens(this.current)

    if (this.items.length > 1) this.defineInterval()
  },
  methods: {
    emitToChildrens(current) {
      this.emitter.emit('advancedCarouselCurrItem', this.items[current])
    },
    changeInterval(play) {
      if (play) {
        clearInterval(this.interval)
      } else {
        this.defineInterval()
      }
    },
    onClick(index, $event) {
      if (this.items.length === 0) return

      if (index === this.current) {
        return
      }

      this.changeitem(this.current, false)

      const total = this.items.length - 1

      if (index < 0) {
        index = total
      }

      if (index > total) {
        index = 0
      }

      this.current = index

      const item = this.items[index]
      if (item && $event) {
        window.dataLayer.push({
          event: 'click',
          name: item.dataset.title || item.dataset['sr-label'] || '',
          section: 'banner',
          component_type: 'cards',
          outbound: false
        })
      }
    },
    previous() {
      this.onClick(this.current - 1)
    },
    next() {
      this.onClick(this.current + 1)
    },
    changeitem(index, active) {
      if (this.items.length === 0) return

      const wrap = this.items[index]

      if (active) {
        wrap.classList.remove('advanced-carousel__item--inactive')
      } else {
        wrap.classList.add('advanced-carousel__item--inactive')
      }
    },
    defineInterval() {
      this.interval = setInterval(() => {
        if (this.loading < 500) {
          this.loading++
        }
        else {
          this.loading = 0
          this.next()
        }
      }, this.timer * 2)
    },
    getResume(item) {
      return item.children[0].dataset.resume
    },
    getTitle(item) {
      return item.children[0].dataset.title
    }
  }
}
</script>
